import React from 'react';
import { Paper, Typography, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Grid from '@mui/material/Grid2';
import { DataGrid } from '@mui/x-data-grid';
import { observer } from 'mobx-react';
import dashboardStore from 'store/dashboardStore';
import M from 'messages';
import classes from './styles';

const DataTableSection = observer(() => (
  <Grid container spacing={2} sx={{ mt: 3 }}>
    <Grid size={{ xs: 12, md: 6 }}>
      <Paper elevation={2} sx={{ padding: 2 }}>
        <Typography display="flex" alignItems="center" mb={2} sx={classes.chartTitle}>
          {M.get('dashboard.viewsByWine')}
          <Tooltip placement="top" title={M.get('dashboard.viewsByWineTooltip')}>
            <HelpOutlineIcon sx={{ marginLeft: '5px', fontSize: '1.3rem' }} />
          </Tooltip>
        </Typography>
        <DataGrid
          rows={dashboardStore.viewsByWine}
          columns={[
            { field: 'wineName', headerName: 'Wine Name', width: 200 },
            { field: 'producer', headerName: 'Producer', width: 180 },
            { field: 'wineCountry', headerName: 'Country', width: 100 },
            { field: 'region', headerName: 'Region', width: 100 },
            { field: 'wineYear', headerName: 'Wine Year', width: 90, type: 'number' },
            { field: 'views', headerName: 'Views', width: 95, type: 'number' },
          ]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
            sorting: {
              sortModel: [
                {
                  field: 'views',
                  sort: 'desc',
                },
              ],
            },
          }}
          sx={{ minHeight: 6 * 52 + 74 }}
          pageSizeOptions={[5]}
          disableSelectionOnClick
          loading={dashboardStore.KPIDataLoading}
        />
      </Paper>
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <Paper elevation={2} sx={{ padding: 2 }}>
        <Typography display="flex" alignItems="center" mb={2} sx={classes.chartTitle}>
          {M.get('dashboard.averageRatingByWine')}
          <Tooltip placement="top" title={M.get('dashboard.averageRatingByWineTooltip')}>
            <HelpOutlineIcon sx={{ marginLeft: '5px', fontSize: '1.3rem' }} />
          </Tooltip>
        </Typography>
        <DataGrid
          rows={dashboardStore.averageRatingByWine}
          columns={[
            { field: 'wineName', headerName: 'Wine Name', width: 200 },
            { field: 'producer', headerName: 'Producer', width: 180 },
            { field: 'wineCountry', headerName: 'Country', width: 100 },
            { field: 'region', headerName: 'Region', width: 100 },
            { field: 'wineYear', headerName: 'Wine Year', width: 90, type: 'number' },
            { field: 'averageRating', headerName: 'Avg Rating', width: 95, type: 'number' },
          ]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
            sorting: {
              sortModel: [
                {
                  field: 'averageRating',
                  sort: 'desc',
                },
              ],
            },
          }}
          sx={{ minHeight: 6 * 52 + 74 }}
          pageSize={5}
          pageSizeOptions={[5]}
          disableSelectionOnClick
          loading={dashboardStore.averageRatingByWineLoading}
        />
      </Paper>
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <Paper elevation={2} sx={{ padding: 2 }}>
        <Typography display="flex" alignItems="center" mb={2} sx={classes.chartTitle}>
          {M.get('dashboard.visitsByRegion')}
          <Tooltip placement="top" title={M.get('dashboard.visitsByRegionTooltip')}>
            <HelpOutlineIcon sx={{ marginLeft: '5px', fontSize: '1.3rem' }} />
          </Tooltip>
        </Typography>
        <DataGrid
          rows={dashboardStore.viewsByRegion}
          columns={[
            { field: 'country', headerName: 'Country', flex: 0.5 },
            { field: 'region', headerName: 'Area', flex: 0.5 },
            { field: 'views', headerName: 'Views', flex: 0.4, type: 'number' },
          ]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
            sorting: {
              sortModel: [
                {
                  field: 'views',
                  sort: 'desc',
                },
              ],
            },
          }}
          pageSize={5}
          sx={{ minHeight: 6 * 52 + 74 }}
          pageSizeOptions={[5]}
          disableSelectionOnClick
          loading={dashboardStore.viewsByCountryLoading}
        />
      </Paper>
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <Paper elevation={2} sx={{ padding: 2 }}>
        <Typography display="flex" alignItems="center" mb={2} sx={classes.chartTitle}>
          {M.get('dashboard.clicksByWine')}
          <Tooltip placement="top" title={M.get('dashboard.clicksByWineTooltip')}>
            <HelpOutlineIcon sx={{ marginLeft: '5px', fontSize: '1.3rem' }} />
          </Tooltip>
        </Typography>
        <DataGrid
          rows={dashboardStore.clicksByWine}
          columns={[
            { field: 'wineName', headerName: 'Wine Name', width: 200 },
            { field: 'producer', headerName: 'Producer', width: 180 },
            { field: 'wineCountry', headerName: 'Country', width: 100 },
            { field: 'region', headerName: 'Region', width: 100 },
            { field: 'wineYear', headerName: 'Wine Year', width: 90, type: 'number' },
            { field: 'clicks', headerName: 'Clicks', width: 95, type: 'number' },
          ]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
            sorting: {
              sortModel: [
                {
                  field: 'clicks',
                  sort: 'desc',
                },
              ],
            },
          }}
          pageSize={5}
          sx={{ minHeight: 6 * 52 + 74 }}
          pageSizeOptions={[5]}
          disableSelectionOnClick
          loading={dashboardStore.clicksByWineLoading}
        />
      </Paper>
    </Grid>
  </Grid>
));

export default DataTableSection;
